export const GIFT_CERTIFICATES_LINK =
  'https://gift.travelata.ru/?utm_source=travelata&utm_medium=banner&utm_campaign=gift_certificates&utm_content=serp_tours';

export const GIFT_CERTIFICATES_EXCLUDED_PATHS: readonly string[] = [
  '/newyear-tours',
  '/ski',
  '/weekend-tours/russia',
  '/railways/search',
  '/earlybooking',
  '/kids',
  '/russia',
  '/tury',
];
